import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPayouts, reset } from "redux/admin/payout/payoutSlice";
import Pagination from "components/Pagination";
import Payouts from "components/Panel/Admin/Payouts";
import { toast } from "react-toastify";

const PayoutsContainer = () => {
  const dispatch = useDispatch();
  const {
    payouts,
    isLoading,
    isError,
    isSuccess,
    message
  } = useSelector((state) => state.adminPayouts);

  const { data, page, pages, per_page, total } = payouts;

  const [filters, setFilters] = useState({
    page: 1,
    per_page: 30,
    status: "",
    amount_min: "",
    amount_max: "",
    holder_name: "",
  });

  // Utility function to clean filters
  const cleanFilters = (filtersToClean) => {
    return Object.fromEntries(
      Object.entries(filtersToClean).filter(([_, value]) => {
        return value !== "" && value !== null && value !== undefined;
      }).map(([key, value]) => {
        // Convert numeric fields to numbers if they're valid
        if ((key === 'amount_min' || key === 'amount_max' || key === 'page' || key === 'per_page') && value !== "") {
          const numValue = parseFloat(value);
          return [key, isNaN(numValue) ? value : numValue];
        }
        return [key, value];
      })
    );
  };

  useEffect(() => {
    dispatch(getPayouts(cleanFilters(filters)));
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(message || "Failed to fetch payouts!");
      dispatch(reset());
    }
  }, [dispatch, isError, message]);

  const handlePageChange = (newPage) => {
    const newFilters = { ...filters, page: newPage };
    setFilters(newFilters);
    dispatch(getPayouts(cleanFilters(newFilters)));
  };

  const handleFilterChange = (newFilters) => {
    const updatedFilters = {
      ...newFilters,
      page: 1, // Reset to first page when filters change
      per_page: filters.per_page
    };
    
    setFilters(updatedFilters);
    dispatch(getPayouts(cleanFilters(updatedFilters)));
  };

  return (
    <div className="bg-black min-h-screen p-4">
      <div className="mb-4">
        <h2 className="text-xl font-semibold text-white-100 mb-2">
          Para Çekme Talepleri
        </h2>
      </div>

      <Payouts
        data={data}
        onFilterChange={handleFilterChange}
        filters={filters}
        isLoading={isLoading}
      />

      {pages > 1 && !isLoading && (
        <Pagination
          currentPage={page || 1}
          totalPages={pages || 1}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default PayoutsContainer;
